<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Zmiana danych osobowych'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-personal-data-change-details-view *ngIf="!modify" [personalDataChange]="personalDataChange" (modifyClicked)="modify = true"></app-personal-data-change-details-view>
  </mat-tab>
  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).personal_data_change.write" mat-stroked-button color="primary" class="add-button" (click)="addDocument()"><mat-icon>add</mat-icon> Dodaj dokument</button>

      <app-document-list [excludeColumns]="['contractType', 'deviceProtocolDate']" [documents]="documents" (changed)="loadDocuments()"></app-document-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [personalDataChange]="personalDataChange"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
